import { App } from '@system/App';
import { elapsedTime } from '@system/ClassicCrash';
// import { elapsedTime } from '@system/ClassicCrash';
 
import gsap from 'gsap';

export class Path {
    private svgPath: SVGPathElement;
    private svgBackground: SVGPathElement;
    private animation: gsap.core.Tween | null = null;
    private curveAnimation: gsap.core.Tween | null = null;
    private oscillationAnimation: gsap.core.Tween | null = null;
    animated: boolean = false
    originalCurve: string

    constructor() {
        this.svgPath = document.querySelector('#curve-path') as SVGPathElement;
        this.svgBackground = document.querySelector('#curve-path-background') as SVGPathElement;
        this.originalCurve = this.svgBackground.getAttribute('d')!
        this.setupPath();
    }

    private setupPath() {
        const pathLength = this.svgPath.getTotalLength();
        this.svgPath.setAttribute('stroke-width', String(App.config.curve.foregroundCurveStroke))
        this.svgBackground.setAttribute('stroke-width', String(App.config.curve.backgroundCurveStroke))
        this.svgPath.style.strokeDasharray = pathLength.toString();
        this.svgPath.style.strokeDashoffset = '0';

    }

    setPathGreen() {
        this.svgBackground.setAttribute('stroke', App.config.curve.curveGreenColor)
    }

    resetPathColor() {
        this.svgBackground.setAttribute('stroke', App.config.curve.curveDefaultColor)
    }


    start(duration: number = 10) {
        if (!this.animated) {
            this.animated = true
            const pathLength = this.svgPath.getTotalLength();
            this.animation = gsap.to(this.svgPath, {
                strokeDashoffset: pathLength,
                duration: duration,
                ease: 'power1.in',
                onComplete: () => {

                    // console.log('Animation complete')
                    this.startCurveAnimation();
                    this.startOscillationAnimation();
                },
                paused: true,
            });
            const time = +(elapsedTime / 1000).toFixed(0)

            this.animation.progress(time / 10).play();
        }

    }


    startCurveAnimation() {

        const originalD = this.svgBackground.getAttribute('d')!;
        const targetD = this.getCurvierPathD();

        this.curveAnimation = gsap.to(this.svgBackground, {
            attr: { d: targetD },
            duration: 84,
            ease: 'power1.out',
            onComplete: () => console.log(''),
            paused: true,
        });
        const time = +(elapsedTime / 1000).toFixed(0) - 10

        this.curveAnimation.progress(time / 84).play();

    }

    startOscillationAnimation() {
        const pathLength = this.svgBackground.getTotalLength();
        const oscillationAmount = pathLength * App.config.curve.oscillationAmount; // 

        this.oscillationAnimation = gsap.to(this.svgPath, {
            strokeDashoffset: `-=${oscillationAmount}`,
            duration: App.config.curve.curveOscillationSpeed,
            ease: 'power1.in',
            yoyo: true, // Reverse the animation
            yoyoEase: 'power4.out',
            repeat: -1, // Infinite loop



        });
    }


    private getCurvierPathD(): string {
        return "M502.477 2.38354C502.477 308.298 502.477 322.015 2 322.015";
    }


    pause() {
        if (this.animation) {
            this.animation.pause();
        }
        if (this.curveAnimation) {
            this.curveAnimation.pause();
        }

        if (this.oscillationAnimation) {
            this.oscillationAnimation.pause()
        }
    }

    stop() {
        this.svgBackground.setAttribute('d', this.originalCurve)
        if (this.animation) {
            this.animation.kill();
            const pathLength = this.svgPath.getTotalLength();
            this.svgPath.style.strokeDashoffset = '0'; // Reset to the start position
            this.animated = false
        }
        if (this.curveAnimation) {
            this.curveAnimation.kill();
        }
        if (this.oscillationAnimation) {
            this.oscillationAnimation.kill();
        }
    }
}
